import { FC } from 'react';
import { Drawer } from '../drawer';
import { ContactInfo, ContactUl, Container, H3, H4, P } from './InfoDrawer.styles';
import { EmailOutlined } from '@mui/icons-material';
import { contacts, getImageUrl, moneyFormatter, offerPrice, offerPriceBus, offerPriceMotorcycle } from '../../utils';
import { tenant } from '../../config/tenant';

interface InfoDrawerProps {
	open: boolean;
	setOpen: (open: boolean) => void;
}

const InfoDrawer: FC<InfoDrawerProps> = ({ open, setOpen }) => {
	const DrawerTitle = <img src={getImageUrl.logoPadrao()} alt={tenant.appName} width={200} />;

	return (
		<Drawer open={open} setOpen={setOpen} anchor='right' title={DrawerTitle}>
			<Container>
				<div>
					<H3>Informações importantes</H3>
					<P>
						Clicando no compre agora o carro é seu! A oferta é finalizada. Para toda compra efetuada
						deve ser pago uma taxa conforme o tipo de veículo ao CANAL DO REPASSE, não reembolsável em caso de desistência.
						Caso não queira "Comprar Agora” você pode deixar uma proposta. No final do prazo leva a
						maior oferta.
					</P>
					<P>
						{offerPrice !== 0 && (
							<>
							Taxa para Carros: {moneyFormatter(offerPrice)},00<br />
							</>
						)}
						{offerPriceMotorcycle !== 0 && (
							<>
							Taxa para Motos: {moneyFormatter(offerPriceMotorcycle)},00<br />
							</>
						)}
						{offerPriceBus !== 0 && (
							<>
							Taxa para Ônibus/Caminhões: {moneyFormatter(offerPriceBus)},00<br />
							</>
						)}
					</P>
				</div>
				<div>
					<H3>Caso necessite de ajuda, entre em contato</H3>
					<ContactUl>
						<li>
							<H4>E-mail</H4>
							<ContactInfo>
								<EmailOutlined fontSize='inherit' />
								<a href={`mailto:${contacts.email}`}>{contacts.email}</a>
							</ContactInfo>
						</li>
					</ContactUl>
				</div>
			</Container>
		</Drawer>
	);
};

export default InfoDrawer;
